import React from 'react';
import { DATA } from '../../components/Data/PaperData';
import {
  OrganizingTeamList,
  SteeringCommitteeList,
  //ProjectList,
  PCList,
  InvitedList,
  //PanelList
} from '../../components/Data/HAXP2026Data';
import {
  Member,
  shuffleArray,
  PCReduced,
  Talk,
  Speaker
} from '../../components/Info';
import {
  Link,
  Button,
  Accordion,
  AccordionItem,
  StructuredListWrapper,
  StructuredListBody,
  StructuredListRow,
  StructuredListCell,
} from 'carbon-components-react';

var MemberList = shuffleArray(OrganizingTeamList);

var items = [];
var shuffledData = DATA.filter(item => item.year === '2026');
shuffledData.sort(
  (item1, item2) =>
    item1.session * 10 + item1.position - (item2.session * 10 + item2.position)
);

shuffledData.forEach(function(item, key) {
  if (item.year === '2026') {
    if (item.invited) {
      items.push({
        id: item.id,
        label: 'Invited Talk | ' + item.title,
      });
    } else if (item.xaip) {
      items.push({
        id: item.id,
        label: 'HAXP 2026 Accepted Paper | ' + item.title,
      });
    }
  }
});

class Page2026 extends React.Component {
  constructor(props) {
    super();
    this.state = {};
  }

  render() {
    return (
      <div
        className="bx--grid bx--grid--full-width landing-page"
        style={{ minHeight: '100vh' }}>
        <div id="program" className="bx--col-lg-12 bx--offset-lg-2">
          <br />
          <br />
          <h4>HAXP 2026 Program</h4>
          <hr />
          <br />
          <br />
          <div className="bx--row">
            <Link
              href="https://chairingtool.com/conferences/haxp26/main-track?role=author"
              style={{ marginLeft: '1rem', textDecoration: 'none' }}
              target="_blank">
              <Button kind="primary" size="sm">
                Submissions
              </Button>
            </Link>
            <Link
              href="https://join.slack.com/t/xaip2021/shared_invite/zt-svdiylde-EwqOBkguynR6jKbi_UKDXA"
              target="_blank"
              style={{ marginLeft: '0.5rem', textDecoration: 'none' }}>
              <Button kind="danger" size="sm">
                Slack
              </Button>
            </Link>
          </div>

          <br />
          <br />
          
                    <br />
          <h4>Schedule (28th June 9:00–18:00)</h4>
          <hr />

          <div>
            <StructuredListWrapper>
              <StructuredListBody>
                <StructuredListCell>9:00–10:15</StructuredListCell>
                <StructuredListCell>
                  Session I
                </StructuredListCell>
                <StructuredListRow>
                  <StructuredListCell>9:00–9:15</StructuredListCell>
                  <StructuredListCell>
                    Welcome & Opening Remarks
                  </StructuredListCell>
                </StructuredListRow>

                <StructuredListRow>
                  <StructuredListCell>9:15–10:15</StructuredListCell>
                  <StructuredListCell>
                    <div className="bx--row">
                      <div className="bx--col-lg-4">
                        <Speaker props={InvitedList[0]} />
                      </div>
                      <div className="bx--col-lg-12">
                        <br />
                        <br />
                        <strong>
                          Invited Talk: Explainable Reasoning and Learning in Ad hoc Teamwork
                        </strong>
                        <br />
                        <br />
                        <Accordion align="start">
                          <AccordionItem
                            className="according-crush"
                            title={<span>Abstract</span>}>
                            AI agents often have to collaborate with other agents (AI, human) that they have not worked with before. Methods considered state of the art for such ad hoc teamwork formulate it primarily as a learning problem, using a large labeled dataset of different situations to model the action choices of different types of agents and determine the actions of the ad hoc agent. Such datasets are not readily available in practical domains, and these methods lack transparency; they also make it difficult to rapidly revise existing knowledge (or models) in response to changes in the domain, team composition, or agents' capabilities. In this talk, I will focus on the core principles and design choices that can lead to architectures that enable reliable, efficient, and transparent reasoning and learning in ad hoc teamwork. I will use results of experimental evaluation in realistic simulation environments and robots to demonstrate that such architectures provide a substantial performance improvement compared with data-driven baselines while using orders of magnitude fewer resources.
                          </AccordionItem>
                          {/* <AccordionItem
                            className="according-crush"
                            title={<span>Bio</span>}>
                            Coming soon!
                          </AccordionItem> */}
                        </Accordion>
                      </div>
                    </div>
                  </StructuredListCell>
                </StructuredListRow>

                <StructuredListRow>
                  <StructuredListCell>
                    10:30–10:50
                    <br />
                  </StructuredListCell>
                  <StructuredListCell>Coffee Break</StructuredListCell>
                </StructuredListRow>
                
                <StructuredListCell>10:50–12:30</StructuredListCell>
                <StructuredListCell>
                  Session II
                </StructuredListCell>
                <StructuredListRow className="no-border">
                  <StructuredListCell>10:50–12:30</StructuredListCell>
                  <StructuredListCell>
                    Paper Session I
                  </StructuredListCell>
                  </StructuredListRow>
                  <StructuredListRow>
                    <StructuredListCell />
                    <StructuredListCell style={{ padding: '0' }}>
                      <Accordion align="start">
                        {shuffledData.map((item, key) => (
                          <React.Fragment key={key}>
                            {item.session === 1 && (
                              <Talk props={item} />
                            )}
                          </React.Fragment>
                        ))}
                      </Accordion>
                  </StructuredListCell>
                </StructuredListRow>

                <StructuredListRow>
                  <StructuredListCell>
                    13:00–14:30
                    <br />
                  </StructuredListCell>
                  <StructuredListCell>Lunch Break</StructuredListCell>
                </StructuredListRow>

                <StructuredListRow className="no-border">
                  <StructuredListCell>14:30–16:00</StructuredListCell>
                  <StructuredListCell>
                    Session III
                  </StructuredListCell>
                </StructuredListRow>
                <StructuredListRow>
                  <StructuredListCell>14:30–15:30</StructuredListCell>
                  <StructuredListCell>
                    <div className="bx--row">
                      <div className="bx--col-lg-4">
                        <Speaker props={InvitedList[1]} />
                      </div>
                      <div className="bx--col-lg-12">
                        <br />
                        <br />
                        <strong>
                          Invited Talk: When Explanations Need Explanation: The Case of the Semi-Factual
                        </strong>
                        <br />
                        <br />
                        <Accordion align="start">
                          <AccordionItem
                            className="according-crush"
                            title={<span>Abstract</span>}>
                            Traditionally, eXplainable Artificial Intelligence (XAI) casts decision-making scenarios as single-shot interactions, in which a single decision is explained to a user in a single step (end of story). However, sequential decision-making scenarios tend to be much more complicated; plans can require a series of explanations for successive steps or explanations that expand on an initial explanation (e.g., unpacking the details of a planning step). Such scenarios require us to consider multiple explanations and their relationships to one another. Here, I consider semi-factual or “even-if” explanations which often need to be explained further, because they can conflict with user understandings. Semi-factuals explain what changes to input features do not change outcomes (unlike counterfactuals which show the feature-changes that change outcomes). For example, if I apply for a $5k loan and am refused, I could be told “Even if you asked for a $100 loan, you would still be refused”. Psychologically, semi-factuals have been shown to weaken people’s causal models; in this loan example, a customer’s belief that the refusal was due to the loan amount is negated. Accordingly, users can find these explanations counter-intuitive, requiring further explanation (e.g., one that might tell them that their credit-score is more important than loan-amount in the system’s decision-making). I show how these “explanations of explanations” can be computed from trend-based analyses of changing feature-importances for different instances and show that people prefer them to single-shot ones. More generally, this work shows some of the complexity that can arise when one moves beyond single-shot scenarios.
                          </AccordionItem>
                          {/* <AccordionItem
                            className="according-crush"
                            title={<span>Bio</span>}>
                            Coming soon!
                          </AccordionItem> */}
                        </Accordion>
                      </div>
                    </div>
                  </StructuredListCell>
                </StructuredListRow>
                
                <StructuredListRow className="no-border">
                  <StructuredListCell>15:35–15:55</StructuredListCell>
                  <StructuredListCell>
                    Paper Session II
                  </StructuredListCell>
                  </StructuredListRow>
                  <StructuredListRow>
                    <StructuredListCell />
                    <StructuredListCell style={{ padding: '0' }}>
                      <Accordion align="start">
                        {shuffledData.map((item, key) => (
                          <React.Fragment key={key}>
                            {item.session === 2 && (
                              <Talk props={item} />
                            )}
                          </React.Fragment>
                        ))}
                      </Accordion>
                  </StructuredListCell>
                </StructuredListRow>

                <StructuredListRow>
                  <StructuredListCell>
                    16:00–16:20
                    <br />
                  </StructuredListCell>
                  <StructuredListCell>Coffee Break</StructuredListCell>
                </StructuredListRow>

                
                <StructuredListRow className="no-border">
                  <StructuredListCell>16:20–18:00</StructuredListCell>
                  <StructuredListCell>
                    Session IV
                  </StructuredListCell>
                </StructuredListRow>
                <StructuredListRow className="no-border">
                  <StructuredListCell>16:20–17:20</StructuredListCell>
                  <StructuredListCell>
                    Paper Session II (Continued)
                  </StructuredListCell>
                </StructuredListRow>
                <StructuredListRow>
                  <StructuredListCell />
                  <StructuredListCell style={{ padding: '0' }}>
                    <Accordion align="start">
                      {shuffledData.map((item, key) => (
                        <React.Fragment key={key}>
                          {item.session === 3 && (
                            <Talk props={item} />
                          )}
                        </React.Fragment>
                      ))}
                    </Accordion>
                  </StructuredListCell>
                </StructuredListRow>
                <StructuredListRow>
                  <StructuredListCell>17:20–18:00</StructuredListCell>
                  <StructuredListCell>
                    <div className="bx--row">
                      <div className="bx--col-lg-16">
                        <strong>
                          Fishbowl Discussion
                        </strong>
                        <br />
                        <br />
                        <Accordion align="start">
                          <AccordionItem
                            open
                            className="according-crush"
                            title={<span>Details</span>}>
                            Coming soon!
                          </AccordionItem>
                        </Accordion>
                      </div>
                    </div>
                  </StructuredListCell>
                </StructuredListRow>
                <StructuredListRow className="no-border">
                  <StructuredListCell>18:00</StructuredListCell>
                  <StructuredListCell>
                    Closing Remarks
                  </StructuredListCell>
                </StructuredListRow>

              </StructuredListBody>
            </StructuredListWrapper>
          </div>

          <br />
          <br />
          <br />
          <br />

          <h4>Accepted Papers</h4>
          <hr />
          <Accordion align="start">
            {shuffledData.map((item, key) => (
              <React.Fragment key={key}>
                <Talk props={item} />
              </React.Fragment>
            ))}
          </Accordion>
          

          <br />
          <br />
          <br />
          <br />

        <div
          id="team"
          className="bx--col-lg-12 bx--offset-lg-2 landing-page__banner">
          <h4>HAXP 2026 Organizing Team</h4>
          <hr />
          <Link href="mailto:haxp.icaps@gmail.com">
            <Button size="small" kind="secondary">
              Contact
            </Button>
          </Link>

          <div className="bx--row publications-page__tab-content">
            {MemberList.map((item, key) => (
              <React.Fragment key={key}>
                <Member props={item} />
              </React.Fragment>
            ))}
          </div>

          <br />
          <br />
          <br />

          <h4>HAXP 2026 Steering Committee</h4>
          <hr />

          <div className="bx--row publications-page__tab-content">
            {SteeringCommitteeList.map((item, key) => (
              <React.Fragment key={key}>
                <Member props={item} />
              </React.Fragment>
            ))}
          </div>

          <br />
          <br />
          <br />
          
          <Accordion align="start">
            <AccordionItem open title="Extended Program Committee">
              <div className="bx--row">
                {PCList.map((item, key) => (
                  <React.Fragment key={key}>
                    <PCReduced props={item} />
                  </React.Fragment>
                ))}
              </div>
            </AccordionItem>
          </Accordion>

          <br />
          <br />
          <br />
        </div>
        
      </div>

    </div>
    );
  }
}

export default Page2026;
